/** Canonieke basis-URL voor SEO (zonder trailing slash). Voor productie: zet VITE_SITE_URL. */
export function siteUrl(): string {
  const v = (import.meta.env.VITE_SITE_URL as string | undefined)?.trim().replace(/\/$/, '');
  if (v) return v;
  if (typeof window !== 'undefined') return window.location.origin;
  return 'https://comforttool.pages.dev';
}
